import { CSSProperties, HTMLAttributes } from 'react'
import { cn } from '@vgw/tailwind-merger'
import { getBrandAssetsConfig } from '@/config/assets-config'

type ContentProps = HTMLAttributes<HTMLElement> & {
  backgroundVariant?: 'default' | 'branded'
}

export const Content = ({
  children,
  className,
  backgroundVariant = 'default',
  ...props
}: ContentProps) => {
  const { backgroundImages } = getBrandAssetsConfig()

  return (
    <main
      className={cn(
        'relative flex w-full flex-1 flex-col items-center bg-surface-secondary',
        backgroundVariant === 'branded' && [
          'before:absolute',
          'before:inset-x-0',
          'before:top-0',
          'before:bg-[image:var(--branded-background-image)]',
          'before:bg-cover',
          'before:bg-top',
          'before:bg-no-repeat',
          'before:aspect-[1024/462]',
        ],
        className,
      )}
      style={
        backgroundVariant === 'branded'
          ? ({
              '--branded-background-image': `url(${backgroundImages.smallBackground})`,
            } as CSSProperties)
          : undefined
      }
      {...props}
    >
      <div className="relative flex w-full max-w-(--breakpoint-max-2xl)">
        {children}
      </div>
    </main>
  )
}
